import { render, staticRenderFns } from "./PollEditor.vue?vue&type=template&id=34c67bc5&scoped=true"
import script from "./PollEditor.vue?vue&type=script&lang=js"
export * from "./PollEditor.vue?vue&type=script&lang=js"
import style0 from "./PollEditor.vue?vue&type=style&index=0&id=34c67bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c67bc5",
  null
  
)

export default component.exports